import BreadCrumbs from '@/components/elements/BreadCrumbs';
import SimpleTextSection from '@/components/elements/SimpleTextSection';
import Spacer from '@/components/elements/Spacer';
import { useTranslation } from 'next-i18next';
import { NextSeo } from 'next-seo';
import React from 'react';

const PrivacyPolicyLayout = () => {
  const { t } = useTranslation(`privacy`);
  return (
    <>
      <NextSeo
        title={t(`page_title`)}
        description={t(`page_title`)}
        openGraph={{
          title: t(`page_title`),
          description: t(`page_description`),
        }}
      />
      <Spacer height={100} />
      <BreadCrumbs pageName={t(`page_name`)} />
      <Spacer height={100} />
      <SimpleTextSection title={t(`page_name`)} content={t(`content`)} />
      <Spacer height={100} />
    </>
  );
};

export default PrivacyPolicyLayout;
